import { KEY_DIGIT } from '~/const/shortcut'

export const bindingOptions = [
  {
    label: '1',
    value: KEY_DIGIT.ONE,
  },
  {
    label: '2',
    value: KEY_DIGIT.TWO,
  },
  {
    label: '3',
    value: KEY_DIGIT.THREE,
  },
  {
    label: '4',
    value: KEY_DIGIT.FOUR,
  },
  {
    label: '5',
    value: KEY_DIGIT.FIVE,
  },
  {
    label: '6',
    value: KEY_DIGIT.SIX,
  },
  {
    label: '7',
    value: KEY_DIGIT.SEVEN,
  },
  {
    label: '8',
    value: KEY_DIGIT.EIGHT,
  },
  {
    label: '9',
    value: KEY_DIGIT.NINE,
  },
]

const VIEW_PATH = {
  ACCOUNTS: '/accounts',
  ANALYTICS_BUSINESS_REPORT: '/analytics/business-report',
  APPS_MANAGEMENT: '/apps-management',
  APP_CONFIG: '/app-config',
  ASO_ADVANCED: '/aso/advanced',
  ASO_OVERVIEW: '/aso/overview',
  BUILDS: '/builds',
  CHECKLISTS: '/checklists',
  COHORTED_ANALYTICS_APP_USAGE: '/ca/app-usage',
  COHORTED_ANALYTICS_COMMUNITY: '/ca/community',
  COHORTED_ANALYTICS_COMPARE_COHORT: '/compare-cohorts',
  COHORTED_ANALYTICS_FAVOURITES: '/ca/favourites',
  COHORTED_ANALYTICS_METRICS_OVERVIEW: '/ca/metrics-overview',
  COHORTED_ANALYTICS_MONET_ADS: '/ca/monet-ads',
  COHORTED_ANALYTICS_MONET_IAP: '/ca/monet-iap',
  COHORTED_ANALYTICS_OVERVIEW: '/ca/overview',
  COHORTED_ANALYTICS_PUBLISHING_OVERVIEW: '/ca/publishing-overview',
  COHORTED_ANALYTICS_STABILITY: '/ca/stability',
  COHORTED_ANALYTICS_USAGE: '/ca/usage',
  COMPETITORS_CLUSTERS: '/competitors/clusters',
  COMPETITORS_MWM: '/competitors/companies',
  DYNAMIC_SCREEN_ARBITRATION: '/dynamic-screens/arbitration',
  DYNAMIC_SCREEN_ASSETS_MANAGEMENT: '/dynamic-screens/assets-management',
  DYNAMIC_SCREEN_NAVIGATION_GRAPHS: '/dynamic-screens/navigation-graphs',
  DYNAMIC_SCREEN_PAGE_CONTAINERS: '/dynamic-screens/page-containers',
  DYNAMIC_SCREEN_PLACEMENTS: '/dynamic-screens/placements',
  DYNAMIC_SCREEN_TEMPLATES: '/dynamic-screens/templates',
  EVENTS: '/events',
  EXTERNAL_LINKS: '/external-links',
  GLOSSARY: '/glossary',
  IN_APP_PURCHASES_GRAPH: '/in-app-purchases/graph',
  IN_APP_PURCHASES_PRODUCTS: '/in-app-purchases/products',
  IN_APP_PURCHASES_SUBSCRIPTIONS: '/in-app-purchases/subscriptions',
  MWM_USERS_AUTHORIZATIONS: '/mwm-users/authorizations',
  MWM_USERS_GROUPS: '/mwm-users/groups',
  MWM_USERS_ROLES: '/mwm-users/roles',
  MWM_USERS_USERS: '/mwm-users/users',
  MY_FILES: '/my-files',
  RELEASES: '/releases',
  REPORTS: '/reports',
  REVIEWS_MANAGEMENT_REPLY_MACRO: '/reviews/management/reply-macros',
  REVIEWS_MANAGEMENT_REPORTING_MACRO: '/reviews/management/reporting-macros',
  REVIEWS_MANAGEMENT_TOPICS: '/reviews/management/topics',
  REVIEWS_MONITORING: '/reviews/monitoring',
  SUMMARY: '/summary',
  VERSIONS: '/versions',
  VIDEOS: '/videos',
}

export const needAppKeyView = [
  VIEW_PATH.APP_CONFIG,
  VIEW_PATH.ANALYTICS_BUSINESS_REPORT,
  VIEW_PATH.ASO_OVERVIEW,
  VIEW_PATH.ASO_ADVANCED,
  VIEW_PATH.BUILDS,
  VIEW_PATH.CHECKLISTS,
  VIEW_PATH.EXTERNAL_LINKS,
  VIEW_PATH.EVENTS,
  VIEW_PATH.IN_APP_PURCHASES_SUBSCRIPTIONS,
  VIEW_PATH.IN_APP_PURCHASES_PRODUCTS,
  VIEW_PATH.IN_APP_PURCHASES_GRAPH,
  VIEW_PATH.REPORTS,
  VIEW_PATH.COHORTED_ANALYTICS_FAVOURITES,
  VIEW_PATH.COHORTED_ANALYTICS_OVERVIEW,
  VIEW_PATH.COHORTED_ANALYTICS_METRICS_OVERVIEW,
  VIEW_PATH.COHORTED_ANALYTICS_PUBLISHING_OVERVIEW,
  VIEW_PATH.COHORTED_ANALYTICS_MONET_ADS,
  VIEW_PATH.COHORTED_ANALYTICS_MONET_IAP,
  VIEW_PATH.COHORTED_ANALYTICS_STABILITY,
  VIEW_PATH.COHORTED_ANALYTICS_USAGE,
  VIEW_PATH.COHORTED_ANALYTICS_APP_USAGE,
  VIEW_PATH.COHORTED_ANALYTICS_COMMUNITY,
  VIEW_PATH.COHORTED_ANALYTICS_COMPARE_COHORT,
  VIEW_PATH.VERSIONS,
  VIEW_PATH.SUMMARY,
]
